<template>
  <banner-container :item="props.item" class="block w-[calc(100dvw-40px)] md:w-360px">
    <div class="banner-image h-135px overflow-hidden rounded">
      <etg-img :src="`fn:${item.cover_image}`" :alt="item.title" class="object-cover w-full h-full" :fetchpriority="imgFetchPriority" />
    </div>
    <p class="banner-description text-base mt-3 w-full h-12 line-clamp-2">
      {{ item.description }}
    </p>
  </banner-container>
</template>

<script lang="ts" setup>
import BannerContainer from '@/components/common/banner-container.vue'

import type { RegionBanner } from '@/types/api'

import { useAppStore } from '@/store/app'

interface Props {
  item: RegionBanner
  index?: number
}

const props = defineProps<Props>()

const appStore = useAppStore()

const imgFetchPriority = computed(() => {
  if (typeof props.index === 'undefined') {
    return undefined
  }

  // 手機版第一畫面只有一張圖
  const firstPrintImageIndexLimit = appStore.isMobileScreen ? 0 : 2

  return props.index <= firstPrintImageIndexLimit ? 'high' : undefined
})
</script>
